'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Popconfirm = require('./Popconfirm');

var _Popconfirm2 = _interopRequireDefault(_Popconfirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Popconfirm2["default"];
module.exports = exports['default'];